"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _trackAgreementOpen = require("./trackAgreementOpen");
Object.keys(_trackAgreementOpen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _trackAgreementOpen[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _trackAgreementOpen[key];
    }
  });
});